import HomePage from '~psp-pages/austrian/home/home.vue'
import RedemptionPage from '~psp-pages/austrian/redemption/redemption.vue'
import Payment from '~psp-pages/austrian/redemption/payment.vue'
import Summary from '~psp-pages/austrian/redemption/summary.vue'

import routerBuilder from './routerBuilder'

const router = routerBuilder({
  HomePage, RedemptionPage, Summary, Payment,
})

export default router
